"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vráti URL adresu pre prihlásenie do SportNetu
 * @param codeChallengeMethod default S256
 * @param responseType default code
 */
const getLoginUrl = (options) => {
    const url = new URL('https://auth.sportnet.online/authorize');
    url.searchParams.append('response_type', options.responseType || 'code');
    url.searchParams.append('client_id', options.app);
    url.searchParams.append('redirect_uri', options.redirectUri);
    url.searchParams.append('code_challenge', options.codeChallenge);
    url.searchParams.append('code_challenge_method', options.codeChallengeMethod || 'S256');
    url.searchParams.append('scope', `${[
        !!options.ppo && `appspace:${options.ppo}`,
        options.openId && 'openid',
        options.scope && options.scope,
    ]
        .filter((e) => !!e)
        .join(' ')}`);
    url.searchParams.append('state', options.state || '');
    return url.toString();
};
exports.default = getLoginUrl;
